import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
  Textarea,
} from "@fluentui/react-components";
import { DeleteDismissFilled } from "@fluentui/react-icons";
import { toast } from "components/FluentToast";
import { VSpace } from "components/Spacer";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "store/AppStore";
import { useRemindersStore } from "store/RemindersStore";

export const DeleteReminderDialog = () => {
  const [
    { reminders, deleteReminderDialog, deleteReminderStatus },
    {
      setRemindersStoreValue,
      setRemindersStoreValues,
      deleteReminder,
      loadReminders,
    },
  ] = useRemindersStore();
  const [{ updatedGrecoCompanies }] = useAppStore();

  const isLoading = deleteReminderStatus === "loading";
  const [comment, setComment] = React.useState("");
  const { t } = useTranslation();

  return (
    <Dialog open={deleteReminderDialog.isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("pct.deleteReminder.label")}</DialogTitle>
          <DialogContent>
            {t("pct.deleteReminderConfirm.label", {
              reminderId: reminders.find(
                (statement) =>
                  statement.reminderId === deleteReminderDialog.reminderId
              )?.reminderId,
            })}
            <VSpace height={20} />
            <div>
              <label>{t("pct.comment.label")}</label>
              <VSpace height={5} />

              <Textarea
                data-help="reminders-delete-comment"
                style={{ width: "100%" }}
                rows={6}
                value={comment}
                disabled={isLoading}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>
            <VSpace height={20} />
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isLoading}
              onClick={() => {
                setRemindersStoreValue("deleteReminderDialog", {
                  isOpen: false,
                  reminderId: null,
                  clientId: null,
                });
              }}
            >
              {t("pct.close.label")}
            </Button>
            <Button
              data-help="reminders-delete-confirm"
              appearance="primary"
              disabled={isLoading}
              icon={
                isLoading ? (
                  <Spinner size="tiny" />
                ) : (
                  <DeleteDismissFilled fontSize={16} />
                )
              }
              onClick={() => {
                deleteReminder(
                  {
                    clientId: deleteReminderDialog.clientId,
                    reminderId: deleteReminderDialog.reminderId,
                    comment: comment,
                    rowVersion: reminders.find(
                      (statement) =>
                        statement.reminderId === deleteReminderDialog.reminderId
                    )?.rowVersion,
                  },
                  () => {
                    setRemindersStoreValues({
                      deleteReminderDialog: {
                        isOpen: false,
                        reminderId: null,
                        clientId: null,
                      },
                    });
                    toast.success(t("greco.success"));
                    loadReminders({
                      reset: true,
                      delay: true,
                      updatedGrecoCompanies,
                    });
                  }
                );
              }}
            >
              {t("pct.delete.label")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
